import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const DragDropFill = ({ color, ...props }: IconProps) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1639_36713)" {...props}>
                <path
                    d="M14 6H16V8H21C21.2652 8 21.5196 8.10536 21.7071 8.29289C21.8946 8.48043 22 8.73478 22 9V16.5L16 13L16.036 21.062L18.259 18.912L20.041 22H9C8.73478 22 8.48043 21.8946 8.29289 21.7071C8.10536 21.5196 8 21.2652 8 21V16H6V14H8V9C8 8.73478 8.10536 8.48043 8.29289 8.29289C8.48043 8.10536 8.73478 8 9 8H14V6ZM22 17.338V21C22.0001 21.1042 21.9839 21.2078 21.952 21.307L19.992 17.913L22 17.338ZM4 14V16H2V14H4ZM4 10V12H2V10H4ZM4 6V8H2V6H4ZM4 2V4H2V2H4ZM8 2V4H6V2H8ZM12 2V4H10V2H12ZM16 2V4H14V2H16Z"
                    fill={color || "#000"}
                />
            </g>
            <defs>
                <clipPath id="clip0_1639_36713">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default DragDropFill
